export default "__VITE_ASSET__Bo8GQEdY__"